export default __webpack_public_path__ + "static/media/loading.95117db4.gif";